import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import KnowledgeFilter from './KnowledgeFilter';
import KnowledgeGrid from './KnowledgeGrid';
import { filterKnowledgeItems } from './utils';
import { useDispatch, useSelector } from 'react-redux';
import { deleteKnowledge, getKnowledge, updateKnowledge } from 'slices/thunk';
import DeleteModal from 'Common/DeleteModal';
import SettingsModal from './components/SettingsModel';
import Loading from 'Common/Components/Loading';

const Knowledge = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = React.useState("");
  const [knowledgeItems, setKnowledgeItems] = React.useState<any[]>([]);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [knowledgeId, setKnowledgeId] = React.useState<string | null>(null);
  const [showSettingsModal, setShowSettingsModal] = React.useState(false);

  const dispatch = useDispatch<any>();
  const dataset = useSelector((state: any) => state.Knowledge.dataset);
  const loading = useSelector((state: any) => state.Knowledge.loading);

  useEffect(() => {
    dispatch(getKnowledge())
  }, [dispatch]);

  useEffect(() => {
    setKnowledgeItems(dataset);
  }, [dataset]);

  const handleOnSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  }

  const handleCreateNew = () => {
    navigate('/knowledge/create');
  };

  const handleEdit = (id: string) => {
    console.log(`Edit button clicked for item with id: ${id}`);
  };

  const handleDelete = (id: string) => {
    setKnowledgeId(id);
    setShowDeleteModal(true);
  };

  const handleSettings = (id: string) => {
    console.log(`Settings button clicked for item with id: ${id}`);
    setShowSettingsModal(true);
    setKnowledgeId(id);
  };

  const handleSettingsSubmit = async (values: any, formik: any) => {
    toast.info(`Settings for "${values.name}" have been saved.`);
    await dispatch(updateKnowledge({ id: knowledgeId!, payload: values }));
    setShowSettingsModal(false);
  }

  const confirmDelete = async () => {
    await dispatch(deleteKnowledge(knowledgeId!));
    // setKnowledgeItems(prevItems => prevItems.filter(item => item.id !== knowledgeId));
    toast.info(`Delete knowledge base successful`);
    setShowDeleteModal(false);
  };

  return (
    <div className="h-[calc(100vh-70px)] flex flex-col">
      <div className="w-full bg-white flex flex-col h-full">
        {/* Header section - fixed */}
        <div className="bg-white border-b border-gray-200 flex-shrink-0">
          <div className="p-3 sm:p-4 md:p-5 lg:p-6 !mb-0">
            <div className="flex flex-col gap-3 mb-4">
              <div className="w-full">
                <h1 className="text-15 font-bold text-gray-900">Knowledge Management</h1>
                <p className="text-xs text-gray-600 mt-1">
                  Manage your knowledge base for enhanced AI context
                </p>
              </div>
            </div>
            <KnowledgeFilter
              onSearch={handleOnSearch}
              textValue={searchText}
              onClearSearch={() => { setSearchText(""); }}
            />
          </div>
        </div>

        {/* Scrollable content area */}
        {loading ? (
          <div className="mt-3 min-h-[100px]"><Loading size="sm" color="blue" isVisible={true} /></div>
        ) : (
          <div className="flex-1 overflow-y-auto">
            <KnowledgeGrid
              knowledgeItems={filterKnowledgeItems(knowledgeItems, searchText)}
              searchText={searchText}
              onCreateNew={handleCreateNew}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onSettings={handleSettings}
            />
          </div>
        )}

        {/* Delete Modal */}
        <DeleteModal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          onDelete={confirmDelete}
          title="Delete Knowledge Base"
          content="Are you sure you want to delete this knowledge base? This action cannot be undone."
          cancelText="Cancel"
          deleteText="Delete"
        />

        <SettingsModal
          open={showSettingsModal}
          initialValues={(Array.isArray(knowledgeItems) ? knowledgeItems : []).find(item => item.id === knowledgeId) || {}}
          title="Settings"
          onClose={() => setShowSettingsModal(false)}
          onSubmit={handleSettingsSubmit}
        />
      </div>
    </div >
  )
}

export default Knowledge
